import { useFormContext } from 'react-hook-form'

import { FormError, FormField, FormItem, FormLabel, Switch } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/RunRiskCalibrationForm/RunRiskCalibrationForm.schema'

export interface PushToDbFieldProps {}

export const PushToDbField: React.FC<PushToDbFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<SchemaType>()

  return (
    <FormField
      name="push_to_db"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Push to DB</FormLabel>
              <FormError />
            </div>
            <Switch
              checked={value}
              onCheckedChange={(val) => setValue('push_to_db', val, { shouldValidate: true })}
            />
          </FormItem>
        )
      }}
    />
  )
}
